import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

const PaymentInfo = ({ imageStyle, isLoading, logo, paymentName }) => {
  if (isLoading) {
    return <div className="deposit-success-notification__payment-skeleton" />;
  }

  return (
    <>
      <div className="deposit-success-notification__logo" style={imageStyle}>
        {!logo && <Icon name="money" />}
      </div>
      <span className="deposit-success-notification__payment-name">{paymentName}</span>
    </>
  );
};

PaymentInfo.propTypes = {
  imageStyle: PropTypes.object,
  isLoading: PropTypes.bool,
  logo: PropTypes.string,
  paymentName: PropTypes.string,
};

export default PaymentInfo;
